import getRootBlockByElement from '../../blocks/helpers/get-root-block-by-element';
import isCustomBlock from '../../blocks/verifiers/is-custom-block';
import getElementAncestorChain from './get-element-ancestor-chain';

const shouldShowLayerSelectTrigger = (element) => {
  if (!element) return false;
  const rootBlock = getRootBlockByElement(element);
  if (!isCustomBlock(rootBlock)) return false;
  return getElementAncestorChain(element).length > 1;
};

export default shouldShowLayerSelectTrigger;
